// removed by extract-text-webpack-plugin
module.exports = {"listItem":"List-module__listItem___2B77G","listItem__media":"List-module__listItem__media___3qZ7h","listItem__content":"List-module__listItem__content___2VcUt","listItem__picture":"List-module__listItem__picture___f_LZy","listItem__content_head":"List-module__listItem__content_head___3Kb3W","listItem__content_bottom":"List-module__listItem__content_bottom___24YlZ","listItem__title":"List-module__listItem__title___2ah4_","listItem__subtitle":"List-module__listItem__subtitle___2Vlur","listItem__right":"List-module__listItem__right___1LENn","deleteButton":"List-module__deleteButton___2NMKK"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/List/List.module.css
// module id = 261
// module chunks = 0